import { BaseRouteService } from 'core/services';

class ItemCategoryRouteService extends BaseRouteService {
    constructor() {
        super('item-categories');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityId,nikoPatientId,dosDateFrom,dosDateTo,billingValidation}', filter);
    }
}

export default ItemCategoryRouteService;
